export default __webpack_public_path__ + "static/media/vxrail.0c42222b.png";